import baseService from './baseService';

export const getNotificationSettings = (userId) => baseService.get(`/member/user_preferences/${userId}`);
export function getNotificationsList(params) {
  return baseService.get('/applicants/notifications', { params });
}

export function updateNotification(id) {
  return baseService.put('/applicants/mark_read_all', {
    notification_id: id,
  });
}

export const updateNotificationSettings = (userId, obj) =>
  baseService.patch(`/member/user_preferences/${userId}`, {
    preference: obj,
  });
